import vForm from "./v-form.vue";

export default Vue => {
  Vue.component("v-form", vForm);
};
